(() => {
  if (customElements.get('alleycat-product-details')) return;

  class AlleycatProductDetails extends HTMLElement {
    constructor() {
      super();
      this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      // Capture also receives toggle events in browsers where they do not bubble.
      this.addEventListener('toggle', this.handleToggle, true);
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.handleToggle, true);
    }

    handleToggle(event) {
      const openedItem = event.target;
      if (
        openedItem.parentElement !== this ||
        !openedItem.matches('details.alleycat-product-details__item') ||
        !openedItem.open
      ) return;

      // Native details name grouping handles this in supporting browsers.
      // Keep the same behavior elsewhere without changing focus or page scroll.
      for (const item of this.children) {
        if (item !== openedItem && item.matches('details.alleycat-product-details__item') && item.open) {
          item.open = false;
        }
      }
    }
  }

  customElements.define('alleycat-product-details', AlleycatProductDetails);
})();